module.exports = __webpack_public_path__ + "static/media/profilePlaceholder.c48b5eec.svg";